export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f5747795d0eca440b71a0416ad688abd71441d866&name=fetchTypeahead!'